<template>
  <q-btn
    stack
    flat
    no-caps
    :icon="icon"
    :to="to"
    @click="_onClick"
    :label="label"
    size="14px"
    color="black"
    :style="style"
  >
  </q-btn>
</template>

<script>
import { QBtn } from 'quasar'
import { lib } from '@giscube/geoportal'
const { getOrCall, onToolClick } = lib.toolUtils

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    tool: {
      type: Object,
      required: true
    },
    menu: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QBtn
  },
  computed: {
    icon () {
      return getOrCall(this.tool.icon, this.tool, this)
    },
    label () {
      return this.$t('tools.' + this.name + '.headerName')
    },
    to () {
      const value = getOrCall(this.tool.to, this.tool, this)
      if (typeof value === 'string') {
        return { name: value }
      } else {
        return value
      }
    },
    style () {
      return {}
    }
  },
  methods: {
    emit (event, value) {
      if (typeof event === 'string' && event) {
        this.$emit('event', { name: event, value })
      } else if (typeof event === 'object' && event.name.toString()) {
        this.$emit('event', event)
      } else {
        this.$except('[HeaderItemHolder.vue] Trying to emit an incorrectly configured event. Check your config.')
      }
    },
    _onClick () {
      onToolClick(this.name, this)
    }
  }
}
</script>

<style scoped>
.q-btn__content div {
  font-size: 10px;
}
</style>
